import request from '@/utils/request'

export function imageTypeList(data) {
    return request({
        url: '/general/imageType/getList',
        method: 'post',
        data: data
    })
}
export function imageTypeAdd(data) {
    return request({
        url: '/general/imageType/add',
        method: 'post',
        data: data
    })
}
export function imageTypeUpd(data) {
    return request({
        url: '/general/imageType/upd',
        method: 'post',
        data: data
    })
}
export function imageTypeDel(data) {
    return request({
        url: '/general/imageType/del',
        method: 'post',
        data: data
    })
}